export const parseJsonConf = <T = any>(el: HTMLElement, attributeName: string): T | null => {
    const conf = el.getAttribute(attributeName);
    if (conf != null) {
        try {
            return JSON.parse(conf);
        } catch (ignore) {
            return null;
        }
    }
    return null;
};

export const parseStorageJsonConf = <T = any>(store: Storage, keyName: string): T | null => {
    const conf = store.getItem(keyName);
    if (conf != null) {
        try {
            return JSON.parse(conf);
        } catch (ignore) {
            return null;
        }
    }
    return null;
};
